import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
// import Charge2DetailsEditable from "../Charge/Charge2DetailsEditable";
import Charge2Card from "../Charge/Charge2Card";
import Time from "../../../Time/Time";
import Constants from "../../../Action/Constants";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { Event } from "../../../Entity/Entities/Event/Event";
import { connect } from "react-redux";
import { PageTransition } from "../../Partials/Spinner/PageTransition";

interface StateInterface {
  newCharge: any;
  isSaving: boolean;
}

class ChargeUpdateDialog extends Component {
  public chargeDetails;

  public state: StateInterface = {
    newCharge: {},
    isSaving: false
  };

  constructor(public props) {
    super(props);

    this.chargeDetails = React.createRef();
  }

  public onCancel = (initializePage: boolean = false): any => {
    this.setState({
      isSaving: false
    }, () => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_CLEAR
      });
  
      if (typeof this.props.onCancel === "function") {
        this.props.onCancel.call(this, initializePage);
      }
    })
  }

  public onSave = (): any => {
    this.chargeDetails?.current?.updateParentState(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_UPDATE_CLEAR
      });

      const charge: any = {
        amount: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.amountForCharge)).replace(",", ".")).toFixed(2)),
        currency: this.state.newCharge?.currencyIdForCharge,
        type: this.state.newCharge?.typeIdForCharge,
        period: this.state.newCharge?.periodForCharge,
        firstDate: Time.formatOrNull(this.state.newCharge?.firstDateForCharge),
        dueDate: Time.formatOrNull(this.state.newCharge?.dueDateForCharge),
        description: this.state.newCharge?.descriptionForCharge,
        invoiceDate: Time.formatOrNull(this.state.newCharge?.invoiceDateForCharge),
        invoiceNumber: this.state.newCharge?.invoiceNumberForCharge,
        vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.newCharge?.vatForCharge)).replace(",", ".")).toFixed(2)),
        isInvoice: this.state.newCharge?.isInvoice
      };

      if (!this.props.charge?.automaticallyCreated) {
        charge.dateOfPeriod = Time.formatOrNull(this.state.newCharge?.dateOfPeriodForCharge);
        charge.dueDate = Time.formatOrNull(Time.firstDateSelectedMonth(this.state.newCharge?.dateOfPeriodForCharge));
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Property) {
        charge.propertyId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Unit) {
        charge.unitId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Contract) {
        charge.contractId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Company) {
        charge.ownerId = this.state.newCharge?.selectedEntityForCharge?.id;
      }
  
      if (this.state.newCharge?.selectedEntityForCharge instanceof Event) {
        charge.eventId = this.state.newCharge?.selectedEntityForCharge?.id;
      }

      if (!this.state.newCharge?.selectedEntityForCharge) {
        charge.propertyId = null;
        charge.unitId = null;
        charge.contractId = null;
        charge.ownerId = null;
        charge.eventId = null;
      }
  
      if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Person) {
        charge.contactId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
      }

      if (this.state.newCharge?.selectedCounterpartyForCharge instanceof Company) {
        charge.companyId = this.state.newCharge?.selectedCounterpartyForCharge?.id;
      }

      if (!this.state.newCharge?.selectedCounterpartyForCharge) {
        charge.contactId = null;
        charge.companyId = null;
      }
  
      return this.saving(() => {
        this.props.dispatch({
          type: Constants.GLOBAL_CHARGE_UPDATE_START,
          payload: {
            chargeId: this.props.charge?.id,
            charge: charge
          },
          onSuccess: () => {
            this.props.dispatch({
              type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
            });

            this.onCancel(true);
          },
          onError: () => {
            return this.setState({
              hasModifiedData: true,
              isSaving: false
            });
          }
        });
      });
    });
  }

  public render() {
    // const isReadonly = this.props?.charge?.isReadonly || this.props?.isReadonly;

    return (
      <Dialog
        className={`dialog dialog-window has-button-padding ${this.props.innerDialogClasses ? this.props.innerDialogClasses : ""}`}
        open={this.props.isOpened}
        onClose={this.onCancel}
        disableBackdropClick={true}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "calc(24px + 2em)"
          }}>
            <div>
              <h4 style={{
                  margin: "15px 0 0 0",
                  padding: this.props.subtitle ? "20px 0 0 0" : "20px 0"
                }}
                >
                {this.props.title}
              </h4>
              {
                this.props.subtitle && (
                <div
                  style={{
                    fontSize: "13px",
                    paddingBottom: "9px",
                    fontWeight: "normal",
                    color: "rgb(137, 137, 137)",
                    margin: 0
                  }}
                  >{this.props.subtitle}</div>
                )
              }
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div style={{padding: "20px"}}>
            <Charge2Card 
              {...this.props}
              dialogPresentation={true}
              chargePayments={this.props.charge?.payments}
            />
            {/* {
              !isReadonly && (
                <Charge2DetailsEditable 
                  {...this.props} 
                  ref={this.chargeDetails}
                  dialogPresentation={true}
                  showEditIcon={true}
                  updateState={(newChargeState, callback?) => {
                    this.setState({
                      newCharge: {
                        ...newChargeState
                      }
                    }, () => {
                      if (typeof callback === "function") {
                        callback();
                      }
                    })
                  }}
                />
              )
            } */}
          </div>
        </DialogContent>

        <div className="dialog-buttons-wrapper">
          <DialogActions>            
            <Button
              color="primary"
              variant="contained"
              onClick={() => this.onCancel(false)}
            >
              {this.trans("dialog-button/close")}
            </Button>

            {/* {
              !isReadonly && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.onSave}
                >
                  {this.trans("dialog-button/save")}
                </Button>
              )
            } */}
          </DialogActions>
        </div>

        <PageTransition isSaving={this.state.isSaving} />
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    component: state.chargeUpdateDialog,
    globalTypes: state.globalTypes,
    properties: state.properties,
    units: state.units
  };
};

export default connect(mapStateToProps)(
  ChargeUpdateDialog
);
